import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { ParkProvider } from "@/contexts/ParkContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { AppLayout } from "@/components/AppLayout";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import TenantsPage from "@/pages/TenantsPage";
import TenantDetailPage from "@/pages/TenantDetailPage";
import LotsPage from "@/pages/LotsPage";
import ParkMapPage from "@/pages/ParkMapPage";
import ReservationsPage from "@/pages/ReservationsPage";
import ReservationDetailPage from "@/pages/ReservationDetailPage";
import InvoicesPage from "@/pages/InvoicesPage";
import InvoiceDetailPage from "@/pages/InvoiceDetailPage";
import ReportsPage from "@/pages/ReportsPage";
import SettingsPage from "@/pages/SettingsPage";
import UsersPage from "@/pages/UsersPage";
import AdminToolsPage from "@/pages/AdminToolsPage";
import MasterToolsPage from "@/pages/MasterToolsPage";
import ParksPage from "@/pages/ParksPage";
import AgencyDashboardPage from "@/pages/AgencyDashboardPage";

function App() {
  return (
    <AuthProvider>
      <ParkProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route
              element={
                <ProtectedRoute>
                  <AppLayout />
                </ProtectedRoute>
              }
            >
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route path="/dashboard" element={<DashboardPage />} />
              <Route path="/tenants" element={<TenantsPage />} />
              <Route path="/tenants/:id" element={<TenantDetailPage />} />
              <Route path="/lots" element={<LotsPage />} />
              <Route path="/park-map" element={<ParkMapPage />} />
              <Route path="/reservations" element={<ReservationsPage />} />
              <Route path="/reservations/:id" element={<ReservationDetailPage />} />
              <Route path="/invoices" element={<InvoicesPage />} />
              <Route path="/invoices/:id" element={<InvoiceDetailPage />} />
              <Route path="/reports" element={<ReportsPage />} />
              <Route path="/settings" element={<ProtectedRoute requireAdmin><SettingsPage /></ProtectedRoute>} />
              <Route path="/admin-tools" element={<ProtectedRoute requireAdmin><AdminToolsPage /></ProtectedRoute>} />
              <Route path="/users" element={<ProtectedRoute requireSuperAdmin><UsersPage /></ProtectedRoute>} />
              <Route path="/parks" element={<ProtectedRoute requireSuperAdmin><ParksPage /></ProtectedRoute>} />
              <Route path="/agency" element={<ProtectedRoute requireSuperAdmin><AgencyDashboardPage /></ProtectedRoute>} />
              <Route path="/master-tools" element={<ProtectedRoute requireMaster><MasterToolsPage /></ProtectedRoute>} />
            </Route>
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </BrowserRouter>
      </ParkProvider>
    </AuthProvider>
  );
}

export default App;
